import type { NavIconName } from "@/components/ui/nav-icon"

import type { NavItemId } from "./items"

export const navIcons: Record<NavItemId, NavIconName> = {
  casino: "casino",
  sports: "sports",
  tournaments: "tournaments",
  promotions: "promotions",
  vip: "vip"
}
